import React from 'react';
import 'semantic-ui-css/components/menu.min.css';
import 'semantic-ui-css/components/segment.min.css';
import 'semantic-ui-css/components/tab.min.css';
import { Tab } from 'semantic-ui-react';
import { withInjectedProps } from '../../Core/InjectedPropsContext';
import './Tabs.scss';
import { ITabsProps } from './types';
const TabsBase: React.FC<ITabsProps> = ({ data }) => {
  return <Tab panes={data} menu={{ secondary: true, pointing: true }}></Tab>;
};

const TabsSection = withInjectedProps(TabsBase);

export { TabsSection };
export default TabsSection;
